import { useEffect } from 'react';
import { useApplicationInsights } from 'live-lesson/shared/util-insights-react';
import { selectPage, usePcpLiveLessonContext } from '../store';

/**
 * Hook to track page changes in PageSwitcher components with Application Insights.
 * 
 * This hook automatically logs page view events when the current page changes,
 * providing consistent telemetry across student and moderator applications.
 * App distinction is handled by the cloudRoleName in Application Insights configuration.
 * 
 * @example
 * ```tsx
 * // In any PageSwitcher component
 * usePageSwitcherTracking();
 * ```
 */
export const usePageSwitcherTracking = (): void => {
    const pageSwitcherPage = usePcpLiveLessonContext(selectPage);
    const insights = useApplicationInsights();

    useEffect(() => {
        insights.logPageView(`PageSwitcher - ${pageSwitcherPage}`, pageSwitcherPage);
    }, [insights, pageSwitcherPage]);
};